import {
	SET_LIST_DESP,
	MODAL_BUDGET,
	ADD_ITEM_BUDGET,
	EDIT_ITEM_TIPOS,
	RESET_ITEMS_BUDGET,
	DELETE_ITEM_BUDGET,
	SELECT_TIPOS,
} from './types';

const initialState = {
	desp: [],
	select: {},
	modal: false,
	items: [],
};

const cadTiposReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_LIST_DESP:
			return {
				...state,
				desp: action.desp,
			};
		case SELECT_TIPOS:
			return {
				...state,
				select: action.select,
			};
		case MODAL_BUDGET:
			return {
				...state,
				modal: !state.modal,
			};
		case ADD_ITEM_BUDGET:
			return {
				...state,
				items: state.items.concat(action.item),
			};
		case EDIT_ITEM_TIPOS:
			return {
				...state,
				items: state.items.map((i, key) =>
					key === action.index
						? { ...i, [action.field]: action.item[action.field] }
						: i,
				),
			};
		case RESET_ITEMS_BUDGET:
			return {
				...state,
				items: [],
			};
		case DELETE_ITEM_BUDGET:
			return {
				...state,
				items: state.items.filter((_, i) => i !== action.index),
			};
		default:
			return state;
	}
};

export default cadTiposReducer;
